import React from 'react';
import { View } from 'react-native';
import { SafeAreaInsetsContext } from 'react-native-safe-area-context';
import { GlobalStatusHeader } from './GlobalStatusHeader';

export const GlobalStatusLayout: React.FC<{ children: React.ReactNode }> = ({ children }) => (
  <View className="flex-1 bg-white">
    <GlobalStatusHeader />
    <SafeAreaInsetsContext.Consumer>
      {(insets) => (
        <SafeAreaInsetsContext.Provider
          value={{ top: 0, bottom: insets?.bottom ?? 0, left: insets?.left ?? 0, right: insets?.right ?? 0 }}
        >
          <View className="flex-1">{children}</View>
        </SafeAreaInsetsContext.Provider>
      )}
    </SafeAreaInsetsContext.Consumer>
  </View>
);
